// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--font-family-base:Rubik,\"Segoe UI\",\"HelveticaNeue-Light\",sans-serif;--max-content-width:1000px;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px;--color-secondary:#fa9300}._19iZh{font-size:14px}._1tW-L,._19iZh{text-align:center}._1tW-L{background:#f3fafe;border:1px solid #c6ddf3;max-width:600px;margin:40px auto;padding:15px}._1tW-L h1{margin-top:0;color:#505b64;font-weight:400}button._1foPD{font-size:19.8px;font-size:1.2375rem}button._3c6Ii{background:#fbfbfb;border:1px solid #d0d4d9}button._3c6Ii:hover{background-color:#ececec}", ""]);
// Exports
exports.locals = {
	"root": "_19iZh",
	"moreWays": "_1tW-L",
	"bigButton": "_1foPD",
	"whiteButton": "_3c6Ii"
};
module.exports = exports;
